import type { Course } from "@brookbush/types";

const CourseBehavioralObjectives = ({
	behavioralObjectives,
}: {
	behavioralObjectives: Course["behavioralObjectives"];
}) => {
	if (!behavioralObjectives) return null;
	return (
		<div className="mx-auto flex max-w-screen-lg flex-col items-center gap-4">
			<h2 className="font-semibold text-2xl">Behavioral Objectives</h2>

			<ol className="flex list-inside list-decimal flex-col gap-2 sm:gap-4">
				{behavioralObjectives.map((behavioralObjective) => (
					<li key={behavioralObjective}>{behavioralObjective}</li>
				))}
			</ol>
		</div>
	);
};

export default CourseBehavioralObjectives;
